module.exports = __webpack_public_path__ + "img/barchart.b71692a8.svg";